var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Chip, Grid2 as Grid, Button, ListItem, ListItemText, Paper, Skeleton, Slide, Stack, Tab, Tabs, TextField, Tooltip, Typography } from "@mui/material";
import React, { useCallback, useEffect, useImperativeHandle, useMemo, useRef } from "react";
import moment from "moment-timezone";
import axiosHttp from '@/api';
import { convertTimestampToSeconds, objectToQueryString, secondsToMMSS } from "@/utils";
import QuestionInput from "@/components/QuestionInput";
import { getKnowledgeBaseInstantAnswer } from "@/services/main";
import useRetry from "@/hooks/useRetry";
import { styled, useTheme } from "@mui/styles";
// import "yet-another-react-lightbox/plugins/captions.css";
import useAppBarHeight from "@/hooks/useAppBarHeight";
// import { SizeMe } from "react-sizeme";
// import PDFViewer from "components/PDFViewer";
// import FileList from "components/Learn/FileList";
import MarkDown from "@/components/MarkdownWrapper";
import AdaptiveVideoPlayer from "@/components/AdaptiveVideoPlayer";
// import ReferenceList from "components/ReferenceList";
import Lottie from "lottie-react";
import ChatLottie from '@/static/chat.json';
import { useSessionContext } from "@/contexts/SessionContext";
import ReferenceList from "./ReferenceList";
var StyledTabs = styled(function (props) { return (_jsx(Tabs, __assign({ scrollButtons: true }, props, { TabIndicatorProps: { children: _jsx("span", { className: "MuiTabs-indicatorSpan" }) } }))); })({
    '& .MuiTabs-indicator': {
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: 'transparent',
    },
    '& .MuiTabs-indicatorSpan': {
        maxWidth: 40,
        width: '100%',
        backgroundColor: 'transparent',
    },
});
var StyledTab = styled(function (props) { return (_jsx(Tab, __assign({ disableRipple: true }, props))); })(function (_a) {
    var _b, _c, _d;
    var theme = _a.theme;
    return ({
        textTransform: 'none',
        fontWeight: 400,
        fontSize: '16px',
        marginRight: '16px',
        minHeight: '36px',
        border: "1px solid ".concat((_b = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _b === void 0 ? void 0 : _b.grey[600]),
        maxHeight: '36px',
        height: '36px',
        borderRadius: '16px',
        padding: '0 16px',
        color: (_d = (_c = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _c === void 0 ? void 0 : _c.text) === null || _d === void 0 ? void 0 : _d.primary,
        '&.Mui-selected': {},
        '&.Mui-focusVisible': {},
    });
});
var Transition = React.forwardRef(function Transition(props, ref) {
    return _jsx(Slide, __assign({ direction: "up", ref: ref }, props));
});
// const useStyles = makeStyles((theme: any) => ({
//     messageText: {
//         fontSize: '0.95rem !important',
//         fontWeight:400,
//         lineHeight: 1.75,
//     },
//     reference: {
//         cursor: 'pointer', 
//         margin: '4px',
//         width: 18, 
//         height: 18, 
//         backgroundColor: theme.palette.grey[500],
//         borderRadius: '50%', 
//         fontSize: 9, 
//         '&::hover': { 
//             backgroundColor: theme?.palette.primary.main 
//         }  
//     }
// }));
export default (function (_a) {
    var _b, _c, _d, _e;
    var knowledgeBaseId = _a.knowledgeBaseId, isPublic = _a.isPublic, _f = _a.onQuestion, onQuestion = _f === void 0 ? function () { } : _f, onTitle = _a.onTitle, innerRef = _a.innerRef;
    // const classes = useStyles()
    var theme = useTheme();
    var appBarHeight = useAppBarHeight();
    var _g = useSessionContext(), token = _g.token, subdomain = _g.subdomain, user = _g.user;
    var retry = useRetry().retry;
    var captionsRef = React.useRef(null);
    var _h = React.useState(null), open = _h[0], setOpen = _h[1];
    var _j = React.useState(null), openFile = _j[0], setOpenFile = _j[1];
    var _k = React.useState(null), question = _k[0], setQuestion = _k[1];
    var _l = React.useState([]), suggestedQuestions = _l[0], setSuggestedQuestions = _l[1];
    var _m = React.useState([]), previousQuestions = _m[0], setPreviousQuestions = _m[1];
    var _o = React.useState(null), questionList = _o[0], setQuestionList = _o[1];
    var _p = React.useState(null), answer = _p[0], setAnswer = _p[1];
    var _q = React.useState(null), suggestAnswers = _q[0], setSuggestAnswers = _q[1];
    var _r = React.useState(null), mostLikelyKnowledgeBaseQuestionList = _r[0], setMostLikelyKnowledgeBaseQuestionList = _r[1];
    var _s = React.useState(null), listUsersExploredQuestions = _s[0], setListUsersExploredQuestions = _s[1];
    var _t = React.useState(false), updateMode = _t[0], setUpdateMode = _t[1];
    var _u = React.useState(null), updatedAnswer = _u[0], setUpdatedAnswer = _u[1];
    var _v = React.useState(null), anchorEl = _v[0], setAnchorEl = _v[1];
    var _w = React.useState(null), knowledgeBase = _w[0], setKnowledgeBase = _w[1];
    var adaptivePlayerRef = useRef(null);
    var _x = React.useState(0), value = _x[0], setValue = _x[1];
    var handleChange = function (event, newValue) {
        console.log("newValue", newValue);
        setValue(newValue);
    };
    var refoOpen = Boolean(anchorEl);
    var id = refoOpen ? 'simple-popover' : undefined;
    var _y = React.useState({
        answerLoading: false
    }), loaders = _y[0], setLoaders = _y[1];
    useImperativeHandle(innerRef, function () { return ({
        clear: function () {
            setQuestion(null);
            setAnswer(null);
            setSuggestAnswers(null);
            setListUsersExploredQuestions(null);
            setUpdateMode(false);
            setUpdatedAnswer(null);
        }
    }); });
    useEffect(function () {
        if (knowledgeBaseId) {
            axiosHttp.get("/?".concat(objectToQueryString({ knowledge_base_id: knowledgeBaseId, action: 'get_knowledge_base_details' })))
                .then(function (res) {
                var _a, _b, _c, _d, _e, _f, _g;
                setKnowledgeBase((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.knowledge_base_details);
                if (((_c = (_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.knowledge_base_details) === null || _c === void 0 ? void 0 : _c.title) && ((_e = (_d = res === null || res === void 0 ? void 0 : res.data) === null || _d === void 0 ? void 0 : _d.knowledge_base_details) === null || _e === void 0 ? void 0 : _e.title) !== "TBD")
                    onTitle((_g = (_f = res === null || res === void 0 ? void 0 : res.data) === null || _f === void 0 ? void 0 : _f.knowledge_base_details) === null || _g === void 0 ? void 0 : _g.title);
            });
        }
    }, [knowledgeBaseId]);
    useEffect(function () {
        if (knowledgeBaseId) {
            axiosHttp.get("/?".concat(objectToQueryString({ knowledge_base_id: knowledgeBaseId, user_id: subdomain ? "".concat(subdomain, "-").concat(user === null || user === void 0 ? void 0 : user.sub) : user === null || user === void 0 ? void 0 : user.sub, action: 'warm_knowledge_base_index' })));
        }
    }, [knowledgeBaseId]);
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var myUserId = useMemo(function () {
        return subdomain ? "".concat(subdomain, "-").concat(user === null || user === void 0 ? void 0 : user.sub) : user === null || user === void 0 ? void 0 : user.sub;
    }, [token]);
    var loadPreviousQuestions = function () {
        setLoaders(function (prev) { return (__assign(__assign({}, prev), { knowledgeBaseQuestionsLoading: true })); });
        axiosHttp.get("/?".concat(objectToQueryString({ knowledge_base_id: knowledgeBaseId, action: 'get_frequent_knowledge_base_questions', "user_id": myUserId, user_timezone: moment.tz.guess() })))
            .then(function (res) {
            var _a, _b, _c, _d;
            console.log("res", res);
            var uniqueSKs = new Set();
            setMostLikelyKnowledgeBaseQuestionList((_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.most_likely_asked_questions) === null || _b === void 0 ? void 0 : _b.map(function (question) { return ({
                SK: question,
            }); }));
            var questionsLists = Object.keys((_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.response).map(function (key) {
                var _a;
                var items = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.response[key];
                var mostRecentTime = items.reduce(function (latest, item) {
                    var itemTime = new Date(item.SK).getTime();
                    return itemTime > latest ? itemTime : latest;
                }, 0);
                return {
                    SK: key,
                    size: items.length,
                    mine: items.filter(function (item) { return item.user_id === myUserId; }).length > 0,
                    time: new Date(mostRecentTime).toISOString() // Convert the timestamp back to a readable format
                };
            });
            console.log("questionsLists", questionsLists);
            questionsLists.forEach(function (item) { return uniqueSKs.add(item.SK); });
            setPreviousQuestions(questionsLists.sort(function (a, b) { return b.size - a.size; }));
            setQuestionList((_d = res === null || res === void 0 ? void 0 : res.data) === null || _d === void 0 ? void 0 : _d.response);
        })
            .finally(function () {
            setLoaders(function (prev) { return (__assign(__assign({}, prev), { knowledgeBaseQuestionsLoading: false })); });
        });
    };
    var imageReferences = useMemo(function () {
        try {
            if (answer && (answer === null || answer === void 0 ? void 0 : answer.image_references))
                return answer === null || answer === void 0 ? void 0 : answer.image_references.map(function (reference) { return JSON.parse(reference); });
        }
        catch (e) {
            console.log(e);
        }
        return [];
    }, [answer]);
    var imageList = useMemo(function () {
        try {
            if (imageReferences && imageReferences.length > 0)
                return imageReferences === null || imageReferences === void 0 ? void 0 : imageReferences.map(function (file) {
                    var src = file === null || file === void 0 ? void 0 : file.s3_url;
                    if (file === null || file === void 0 ? void 0 : file.file_path) {
                        src = file === null || file === void 0 ? void 0 : file.file_path;
                    }
                    return { src: src, title: file === null || file === void 0 ? void 0 : file.file_name, description: file === null || file === void 0 ? void 0 : file.reason };
                });
        }
        catch (e) {
            console.log(e);
        }
        return [];
    }, [imageReferences]);
    var filterQuestions = useCallback(function (questions) {
        if (!questions)
            return [];
        if (value === 0)
            return previousQuestions;
        if (value === 2)
            return mostLikelyKnowledgeBaseQuestionList;
        return previousQuestions
            .filter(function (q) {
            if (value === 1)
                if (q.mine)
                    return true;
            return false;
        })
            .sort(function (a, b) {
            if (value === 1) {
                return new Date(b.time).getTime() - new Date(a.time).getTime(); // Sort by 'time' descending
            }
            return 0;
        });
    }, [value, previousQuestions, myUserId, mostLikelyKnowledgeBaseQuestionList]);
    useEffect(function () {
        var _a;
        if (question && questionList && answer) {
            var questions = (_a = questionList[answer === null || answer === void 0 ? void 0 : answer.SK]) === null || _a === void 0 ? void 0 : _a.sort(function (a, b) {
                if (a.SK < b.SK)
                    return -1;
                if (a.SK > b.SK)
                    return 1;
                return 0;
            });
            var uniqueEmails = new Set();
            var uniqueRecords = [];
            if (questions) {
                for (var _i = 0, questions_1 = questions; _i < questions_1.length; _i++) {
                    var record = questions_1[_i];
                    var user_email = record.user_email;
                    if (!uniqueEmails.has(user_email)) {
                        uniqueEmails.add(user_email);
                        uniqueRecords.push(record);
                    }
                }
            }
            setListUsersExploredQuestions(uniqueRecords);
        }
    }, [question, questionList, answer, mostLikelyKnowledgeBaseQuestionList]);
    useEffect(function () {
        if (knowledgeBaseId)
            loadPreviousQuestions();
    }, [knowledgeBaseId, answer]);
    useEffect(function () {
        setListUsersExploredQuestions([]);
        onQuestion(question);
    }, [question]);
    var pollForAudio = useCallback(function (message) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.log("POLLING FOR AUDIO", answer);
                    if (!answer)
                        return [2 /*return*/, Promise.resolve(true)];
                    return [4 /*yield*/, getKnowledgeBaseInstantAnswer({
                            query: {
                                knowledge_base_id: knowledgeBaseId,
                                user_timezone: moment.tz.guess()
                            },
                            body: {
                                question: message,
                                user_asked_flag: false
                            }
                        })
                            .then(function (res) {
                            var _a, _b, _c, _d;
                            var response = ((_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.response_struct) === null || _b === void 0 ? void 0 : _b.answer_list) || ((_d = (_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.response_struct) === null || _d === void 0 ? void 0 : _d.answers_list);
                            if ((response === null || response === void 0 ? void 0 : response.answer_audio_generation) === 'completed') {
                                if ((answer === null || answer === void 0 ? void 0 : answer.SK) === (response === null || response === void 0 ? void 0 : response.SK))
                                    setAnswer(response);
                            }
                            else {
                                throw new Error("Audio generation not completed");
                            }
                        })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); }, [answer]);
    useEffect(function () {
        if (answer) {
            if ((answer === null || answer === void 0 ? void 0 : answer.answer_audio_generation) !== 'completed') {
                setTimeout(function () {
                    retry(function () { return pollForAudio(answer === null || answer === void 0 ? void 0 : answer.SK); }, function () { console.log('references loading retry called...'); }, 50, 5, function () { return true; });
                }, 2000);
            }
        }
    }, [answer]);
    var handleSendMessage = function (message) {
        setQuestion(message);
        setLoaders(function (prev) { return (__assign(__assign({}, prev), { answerLoading: true })); });
        axiosHttp.post("/?".concat(objectToQueryString({ knowledge_base_id: knowledgeBaseId, action: 'generate_answer_from_knowledge_base_index', user_id: myUserId, user_timezone: moment.tz.guess() })), {
            question: message
        })
            .then(function (response) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
            setLoaders(function (prev) { return (__assign(__assign({}, prev), { answerLoading: false })); });
            if ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.question_list) {
                var sq = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.question_list.map(function (q) { return ({ SK: q }); });
                console.log("THERE", sq);
                if (sq.length > 0) {
                    console.log("THERE", sq[0]);
                    setQuestion((_c = sq[0]) === null || _c === void 0 ? void 0 : _c.SK);
                    handleLoadPreviousAnswer((_d = sq[0]) === null || _d === void 0 ? void 0 : _d.SK);
                    setSuggestedQuestions(null);
                }
                else {
                    setSuggestedQuestions((_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.question_list.map(function (q) { return ({ SK: q }); }));
                }
            }
            else if ((_f = response === null || response === void 0 ? void 0 : response.data) === null || _f === void 0 ? void 0 : _f.answer_struct) {
                setQuestion((_h = (_g = response === null || response === void 0 ? void 0 : response.data) === null || _g === void 0 ? void 0 : _g.answer_struct) === null || _h === void 0 ? void 0 : _h.SK);
                setSuggestedQuestions(null);
                if ((_j = response === null || response === void 0 ? void 0 : response.data) === null || _j === void 0 ? void 0 : _j.answer_struct) {
                    setAnswer(__assign(__assign({}, (_k = response === null || response === void 0 ? void 0 : response.data) === null || _k === void 0 ? void 0 : _k.answer_struct), { audio_pre_signed_url: ((_l = response === null || response === void 0 ? void 0 : response.data) === null || _l === void 0 ? void 0 : _l.audio_pre_signed_url) || ((_o = (_m = response === null || response === void 0 ? void 0 : response.data) === null || _m === void 0 ? void 0 : _m.answer_struct) === null || _o === void 0 ? void 0 : _o.audio_pre_signed_url) }));
                }
            }
        })
            .catch(function (error) {
            console.log("error", error);
            handleSendMessage(message);
        })
            .finally(function () {
            // loadPreviousQuestions()
        });
    };
    var handleSuggestAnswer = function () {
        setLoaders(function (prev) { return (__assign(__assign({}, prev), { suggestLoading: true })); });
        axiosHttp.post("/?".concat(objectToQueryString({
            knowledge_base_id: knowledgeBaseId,
            action: 'update_knowledge_base_answer',
            user_timezone: moment.tz.guess()
        })), {
            question: question,
            updated_answer: updatedAnswer
        })
            .then(function (res) {
            setUpdateMode(false);
            setUpdatedAnswer(null);
            handleLoadPreviousAnswer(question);
        })
            .finally(function () {
            setLoaders(function (prev) { return (__assign(__assign({}, prev), { suggestLoading: true })); });
        });
    };
    var handleLoadPreviousAnswer = function (message, generateNewAnswer) {
        if (generateNewAnswer === void 0) { generateNewAnswer = false; }
        setLoaders(function (prev) { return (__assign(__assign({}, prev), { answerLoading: true })); });
        if (value === 2 && generateNewAnswer) {
            handleSendMessage(message);
        }
        else {
            getKnowledgeBaseInstantAnswer({
                query: {
                    knowledge_base_id: knowledgeBaseId,
                    user_timezone: moment.tz.guess()
                },
                body: {
                    question: message,
                    user_asked_flag: true,
                    audio_required: false
                }
            })
                .then(function (res) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
                console.log("res", res);
                if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.status) === "ok") {
                    if (((_c = (_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.response_struct) === null || _c === void 0 ? void 0 : _c.suggested_answers) && ((_e = (_d = res === null || res === void 0 ? void 0 : res.data) === null || _d === void 0 ? void 0 : _d.response_struct) === null || _e === void 0 ? void 0 : _e.suggested_answers.length) > 0) {
                        setSuggestAnswers((_g = (_f = res === null || res === void 0 ? void 0 : res.data) === null || _f === void 0 ? void 0 : _f.response_struct) === null || _g === void 0 ? void 0 : _g.suggested_answers);
                    }
                    setAnswer(__assign(__assign({}, (((_j = (_h = res === null || res === void 0 ? void 0 : res.data) === null || _h === void 0 ? void 0 : _h.response_struct) === null || _j === void 0 ? void 0 : _j.answer_list) || ((_l = (_k = res === null || res === void 0 ? void 0 : res.data) === null || _k === void 0 ? void 0 : _k.response_struct) === null || _l === void 0 ? void 0 : _l.answers_list))), { course_file_paths: (_o = (_m = res === null || res === void 0 ? void 0 : res.data) === null || _m === void 0 ? void 0 : _m.response_struct) === null || _o === void 0 ? void 0 : _o.course_file_path }));
                }
                else {
                    throw new Error("No answer found");
                }
            })
                .catch(function (error) {
                console.log("error", error);
            })
                .finally(function () {
                setLoaders(function (prev) { return (__assign(__assign({}, prev), { answerLoading: false })); });
            });
        }
    };
    return (_jsxs(Box, { children: [!question && !answer ?
                _jsx(QuestionInput, { placeholder: isPublic ? 'Ask any question about HitWit' : undefined, onSendMessage: function (msg) { return handleSendMessage(msg); } }) :
                _jsx(Typography, { variant: "h6", sx: {}, children: question }), loaders.answerLoading ?
                _jsx(Box, { sx: { mt: 2 }, children: _jsx(Box, { mt: 2, py: 2, sx: { width: '100%', borderRadius: '16px', padding: '16px 0px 16px 0px !important', display: 'flex', flexDirection: 'row', alignItems: 'center' }, children: _jsxs(Stack, { sx: { width: '100%', height: '80vh' }, direction: "column", alignItems: "center", justifyContent: "center", children: [_jsx(Box, { sx: { width: 200 }, children: _jsx(Lottie, { loop: true, animationData: ChatLottie }) }), _jsx(Typography, { variant: 'body1', sx: { mt: 2 }, children: "Generating answer.. May take 30-60 seconds" })] }) }) })
                :
                    answer ?
                        _jsx(Grid, { container: true, children: _jsx(Grid, { spacing: 2, size: { sm: 12, xs: 12 }, children: _jsxs(Box, { sx: { mr: 4 }, children: [_jsx(Box, { children: listUsersExploredQuestions && !isPublic &&
                                                _jsxs(Typography, { sx: { my: 1 }, variant: "body2", children: ["First asked by ", ((_b = listUsersExploredQuestions[0]) === null || _b === void 0 ? void 0 : _b.user_name) || "You", " @ ", moment.utc((_c = listUsersExploredQuestions[0]) === null || _c === void 0 ? void 0 : _c.SK).local().format('MMM DD, hh:mm A')] }) }), updateMode ?
                                            _jsxs(Box, { sx: { mt: 2 }, children: [_jsx(TextField, { multiline: true, fullWidth: true, placeholder: "Suggest an answer..", minRows: 6, value: updatedAnswer, onChange: function (e) { return setUpdatedAnswer(e.target.value); } }), _jsxs(Stack, { direction: "row", justifyContent: "flex-end", sx: { my: 1 }, children: [_jsx(Button, { variant: "text", sx: { m: 1 }, onClick: function () {
                                                                    setUpdatedAnswer(null);
                                                                    setUpdateMode(false);
                                                                }, children: "Cancel" }), _jsx(Button, { sx: { m: 1 }, variant: "contained", onClick: function () {
                                                                    handleSuggestAnswer();
                                                                }, children: "Submit" })] })] }) :
                                            _jsxs(Box, { sx: { mt: 2 }, children: [_jsx(MarkDown, { content: answer === null || answer === void 0 ? void 0 : answer.answer }), _jsx(Stack, { sx: { mt: 1 }, direction: "row", alignItems: "center", children: _jsx(Box, { sx: { flexGrow: 1 } }) }), answer && (answer === null || answer === void 0 ? void 0 : answer.references) && (answer === null || answer === void 0 ? void 0 : answer.references.length) > 0 ?
                                                        _jsx(ReferenceList, { references: answer === null || answer === void 0 ? void 0 : answer.references })
                                                        : null, _jsxs(Box, { sx: { mt: 4, maxWidth: { xs: '100%', sm: "100%", md: '50%' } }, children: [(answer === null || answer === void 0 ? void 0 : answer.video_urls) && typeof (answer === null || answer === void 0 ? void 0 : answer.video_urls) === 'object' && (answer === null || answer === void 0 ? void 0 : answer.video_urls.length) > 0 ?
                                                                _jsxs(_Fragment, { children: [_jsx(Typography, { variant: "h6", sx: {}, children: "Video" }), answer === null || answer === void 0 ? void 0 : answer.video_urls.map(function (source) {
                                                                            return (_jsx(Box, { sx: { my: 1 }, children: _jsx(AdaptiveVideoPlayer, { innerRef: adaptivePlayerRef, videoUrl: source }) }));
                                                                        })] }) : null, (answer === null || answer === void 0 ? void 0 : answer.transcript_references) && ((_d = answer === null || answer === void 0 ? void 0 : answer.transcript_references) === null || _d === void 0 ? void 0 : _d.length) > 0 &&
                                                                _jsxs(Box, { sx: { my: 2 }, children: [_jsx(Typography, { variant: "subtitle2", children: "References" }), _jsx(Stack, { sx: { mt: 0.5 }, direction: "row", flexWrap: 'wrap', children: (answer === null || answer === void 0 ? void 0 : answer.transcript_references) && ((_e = answer === null || answer === void 0 ? void 0 : answer.transcript_references) === null || _e === void 0 ? void 0 : _e.length) > 0 &&
                                                                                (answer === null || answer === void 0 ? void 0 : answer.transcript_references.map(function (tr) {
                                                                                    var translatedTime = convertTimestampToSeconds(tr === null || tr === void 0 ? void 0 : tr.starting_timestamp);
                                                                                    return (_jsx(Tooltip, { title: tr === null || tr === void 0 ? void 0 : tr.relevance_reason, children: _jsx(Typography, { onClick: function () {
                                                                                                var _a;
                                                                                                (_a = adaptivePlayerRef === null || adaptivePlayerRef === void 0 ? void 0 : adaptivePlayerRef.current) === null || _a === void 0 ? void 0 : _a.seekTo(translatedTime);
                                                                                            }, sx: { cursor: 'pointer', mx: 0.5, textDecoration: 'underline', }, color: "primary", variant: "body2", children: secondsToMMSS(translatedTime) }) }));
                                                                                })) })] }), (answer === null || answer === void 0 ? void 0 : answer.video_urls) && typeof (answer === null || answer === void 0 ? void 0 : answer.video_urls) === 'string' ?
                                                                _jsxs(_Fragment, { children: [_jsx(Typography, { variant: "h6", sx: {}, children: "Video" }), _jsx(Box, { sx: { my: 1 }, children: _jsx(AdaptiveVideoPlayer, { videoUrl: answer === null || answer === void 0 ? void 0 : answer.video_urls }) })] }) : null] }), answer &&
                                                        _jsx(Stack, { sx: { mt: 2 }, direction: "row", children: _jsx(Button, { variant: "contained", sx: { mt: 1 }, onClick: function () {
                                                                    setAnswer(null);
                                                                    setQuestion(null);
                                                                    // loadPreviousQuestions() 
                                                                }, children: "Got it" }) })] })] }) }) }) :
                        _jsx(Box, { sx: { mt: 2 }, children: (loaders === null || loaders === void 0 ? void 0 : loaders.courseQuestionsLoading) ?
                                _jsx(Box, { sx: { mt: 2 }, children: _jsx(Skeleton, { sx: { my: 0.5, borderRadius: 1 }, variant: "rectangular", width: "100%", height: 500 }) }) :
                                _jsx(Grid, { spacing: 2, sx: { mt: 2 }, container: true, children: _jsx(Grid, { size: { sm: 12, xs: 12 }, children: _jsxs(Paper, { sx: { p: 2, borderRadius: 2 }, elevation: 0, children: [(!suggestedQuestions || suggestedQuestions && suggestedQuestions.length === 0) &&
                                                    _jsx(Box, { display: "flex", id: "selecting-tabs", flexDirection: "row", justifyContent: "flex-start", children: _jsxs(StyledTabs, { value: value, onChange: handleChange, children: [_jsx(StyledTab, { value: 0, label: "Frequently asked" }), !isPublic && _jsx(StyledTab, { value: 1, label: "My recent questions" }), _jsx(StyledTab, { value: 2, label: isPublic ? "Suggested questions" : "Most likely questions" })] }) }), _jsx(Box, { children: (filterQuestions(previousQuestions)).length > 0 ?
                                                        (filterQuestions(previousQuestions)).map(function (pq) {
                                                            return (_jsx(ListItem, { sx: { cursor: 'pointer' }, onClick: function () {
                                                                    setQuestion(pq === null || pq === void 0 ? void 0 : pq.SK);
                                                                    handleLoadPreviousAnswer(pq === null || pq === void 0 ? void 0 : pq.SK, true);
                                                                    setSuggestedQuestions(null);
                                                                }, disablePadding: true, children: _jsx(ListItemText, { primary: pq === null || pq === void 0 ? void 0 : pq.SK, secondary: _jsx(Stack, { sx: { py: 1 }, direction: "row", alignItems: "center", children: value === 0 && (pq === null || pq === void 0 ? void 0 : pq.size) > 0 && !isPublic && (_jsx(Chip, { color: "primary", variant: "outlined", size: "small", sx: { mx: 0.5 }, label: "Asked ".concat(pq === null || pq === void 0 ? void 0 : pq.size, " time").concat((pq === null || pq === void 0 ? void 0 : pq.size) > 1 ? 's' : '') })) }) }) }));
                                                        }) :
                                                        _jsx(Box, { sx: { my: 3, px: 2 }, children: _jsx(Typography, { sx: {}, variant: "body1", children: "No questions" }) }) })] }) }) }) })] }));
});
